export default __webpack_public_path__ + "static/media/terms_and_cond.fe946258.pdf";